// For an extraction, all the file results (Again, usually, they are excel files.)
import { productBundleExtractionOutputFilesService } from '@/services/estimation/product-bundle-extraction-output-files.service';
import axios from 'axios';

const initialState = () => ({
  productBundleExtractionOutputFile: null,
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  productBundleExtractionOutputFiles: null,
};

const actions = {
  // Get product bundle extraction output file
  getProductBundleExtractionOutputFile({ commit }, { bundleId, fileId }) {
    if (cancelTokens.productBundleExtractionOutputFiles) {
      cancelTokens.productBundleExtractionOutputFiles.cancel('Multiple requests.');
    }
    cancelTokens.productBundleExtractionOutputFiles = CancelToken.source();

    commit('GET_OUTPUT_FILE');
    return productBundleExtractionOutputFilesService
      .getProductBundleExtractionOutputFile({
        bundleId,
        fileId,
        cancelToken: cancelTokens.productBundleExtractionOutputFiles,
      })
      .then(
        (response) => {
          commit('SUCCESS', response);
        },
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },

  // Download product bundle extraction file
  downloadProductBundleExtractionOutputFile({ commit }, { bundleId, fileId, name }) {
    return productBundleExtractionOutputFilesService.downloadOutputFile({ bundleId, fileId, name }).catch((error) => {
      commit('ERROR', error.response);
      throw error;
    });
  },

  // Upload product bundle extraction file
  uploadProductBundleExtractionOutputFile({ commit }, { bundleId, files }) {
    commit('UPLOAD_OUTPUT_FILE');
    return productBundleExtractionOutputFilesService.uploadOutputFile({ bundleId, files }).then(
      (response) => {
        commit('SUCCESS_UPLOADING_OUTPUT_FILE', response);
        commit('productBundleExtraction/ADD_PRODUCT_BUNDLE_EXTRACTION_OUTPUT_FILE', response, { root: true });
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },

  // Delete product bundle extraction output file by ID
  deleteProductBundleExtractionOutputFileById({ commit }, { bundleId, fileId }) {
    return productBundleExtractionOutputFilesService.deleteExtractionOutputFileById({ bundleId, fileId }).then(
      (response) => {
        commit('productBundleExtraction/DELETE_OUTPUT_FILE_SUCCESS', { fileId }, { root: true });
        return response;
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_OUTPUT_FILE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.productBundleExtractionOutputFile = null;
  },
  SUCCESS(state, outputFile) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleExtractionOutputFile = outputFile;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
  UPLOAD_OUTPUT_FILE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_UPLOADING_OUTPUT_FILE(state, response) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
  },
};

const getters = {
  productBundleExtractionOutputFile: (state) => state.productBundleExtractionOutputFile,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const productBundleExtractionOutputFiles = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
